export default __webpack_public_path__ + "static/media/Foto-13.4029fea3.png";